<script>
import { connect } from 'vuex-connect';
import PauseBox from '../scenes/PauseBox.vue';

export default connect({
  gettersToProps: {
    hasCalledHelp: 'hasCalledHelp',
    station: 'currentStation',
    timerStatus: 'timerStatus',
  },
  // stateToProps: {
  //   loading: state => state.launcher.loadings.getStation,
  // },
  actionsToEvents: {
    'launch-tutorial': 'startTutorial',
  },
})('PauseBox', PauseBox);
</script>
